import React, { Component } from 'react'
import styled from 'styled-components'

import Modal from '../Modal'
import Input from '../Input'
import CheckInput from '../CheckInput'

import Gas from 'components/Svg/ic-gas.svg'
import Electricity from 'components/Svg/ic-eletricidade.svg'

import { replaceDots } from 'utils'

export default class EditPricesModal extends Component {
    onUpdate = () => {
        const { form, updatePrices } = this.props
        if (!form.invalid) {
            updatePrices()
        }
    }

    renderButtons = [
        {
            label: 'cancelar',
            primary: false,
            click: () => this.props.toogler({ opened: false })
        },
        {
            label: 'guardar',
            primary: true,
            click: () => this.onUpdate()
        }
    ]

    isValid = (obj, field) => {
        const { form } = this.props

        if (!obj[field]) {
            form.invalid = true
            return false
        } else {
            form.invalid = false
        }
    }

    renderErrorMessage = (value) => {
        if (!value) {
            return `Campo de preenchimento obrigatório`
        }
    }
    render() {
        let {
            toogler,
            form,
            onChange,
            electricityPriceList,
            gasPriceList,
            timeCycle
        } = this.props

        return(
            <Modal
            title={`Ajustar Preços do meu tarifário`}
            toogler
            buttons={this.renderButtons}
            onClick={() => toogler({ opened: false })}>
                <Wrapper>
                    <Row>
                        {electricityPriceList &&
                            <Col eletricty={true}>
                                <Title style={{ color: '#FF8E2A' }}><EletricityIcon src={Electricity} />Eletricidade</Title>
                                <InputBox first={true}>
                                    <InputForm 
                                        onlyDecimalNumbers={true}
                                        label={`Termo Potência (€/dia)`}
                                        maxLength={6}
                                        valid={this.isValid(form.electricity_prices, 'termo_fixo')}
                                        errorMessage={this.renderErrorMessage(form.electricity_prices && form.electricity_prices.termo_fixo)}
                                        value={form.electricity_prices && replaceDots(form.electricity_prices.termo_fixo)} 
                                        onChange={(e) => onChange('electricity_prices', 'termo_fixo', e)}/>
                                </InputBox>
                                {timeCycle === 's' && 
                                    <InputBox>
                                        <InputForm 
                                                onlyDecimalNumbers={true}
                                                label={`Energia (€/kWh)`}
                                                maxLength={6}
                                                valid={this.isValid(form.electricity_prices, 'cheia')}
                                                errorMessage={this.renderErrorMessage(form.electricity_prices && form.electricity_prices.cheia)}
                                                value={form.electricity_prices && replaceDots(form.electricity_prices.cheia)} 
                                                onChange={(e) => onChange('electricity_prices', 'cheia', e)}/>
                                    </InputBox>
                                }
                                {timeCycle !== 's' &&
                                    <InputBox>
                                        <InputForm
                                            onlyDecimalNumbers={true}
                                            label={`Energia - ${timeCycle === 'b' ? 'Fora do Vazio' : 'Cheias'} (€/kWh)`} 
                                            maxLength={6}
                                            valid={this.isValid(form.electricity_prices, 'cheia')}
                                            errorMessage={this.renderErrorMessage(form.electricity_prices && form.electricity_prices.cheia)}
                                            value={form.electricity_prices && replaceDots(form.electricity_prices.cheia)} 
                                            onChange={(e) => onChange('electricity_prices', 'cheia', e)}/>
                                    </InputBox>
                                }
                                {timeCycle !== 's' && 
                                    <InputBox>
                                        <InputForm
                                            onlyDecimalNumbers={true}
                                            label={`Energia - Vazio (€/kWh)`} 
                                            maxLength={6}
                                            valid={this.isValid(form.electricity_prices, 'vazio')}
                                            errorMessage={this.renderErrorMessage(form.electricity_prices, 'vazio')}
                                            value={form.electricity_prices && replaceDots(form.electricity_prices.vazio)} 
                                            onChange={(e) => onChange('electricity_prices', 'vazio', e)}/>
                                    </InputBox>
                                }
                                {timeCycle !== 'b' && timeCycle !== 's' &&
                                    <InputBox>
                                        <InputForm 
                                            label={`Energia - Ponta (€/kWh)`}
                                            onlyDecimalNumbers={true}
                                            maxLength={6}
                                            valid={this.isValid(form.electricity_prices, 'ponta')}
                                            errorMessage={this.renderErrorMessage(form.electricity_prices && form.electricity_prices.ponta)}
                                            value={form.electricity_prices && replaceDots(form.electricity_prices.ponta)} 
                                            onChange={(e) => onChange('electricity_prices', 'ponta', e)}/>
                                    </InputBox>
                                }
                            </Col>
                        }
                        {gasPriceList &&
                            <Col hasEletricity={electricityPriceList} eletricty={false}>
                                <Title style={{ color: '#00BDED' }}><GasIcon src={Gas}/>Gás Natural</Title>
                                <InputBox first={true}>
                                    <InputForm 
                                        label={`Termo Fixo (€/dia)`}
                                        onlyDecimalNumbers={true}
                                        maxLength={6}
                                        valid={this.isValid(form.gas_prices, 'termo_fixo')}
                                        errorMessage={this.renderErrorMessage(form.gas_prices && form.gas_prices.termo_fixo)}
                                        value={form.gas_prices && replaceDots(form.gas_prices.termo_fixo)} 
                                        onChange={(e) => onChange('gas_prices', 'termo_fixo', e)}/>
                                </InputBox>
                                <InputBox>
                                    <InputForm 
                                        label={`Energia (€/kWh)`} 
                                        onlyDecimalNumbers={true}
                                        maxLength={6}
                                        valid={this.isValid(form.gas_prices, 'termo_energia')}
                                        errorMessage={this.renderErrorMessage(form.gas_prices && form.gas_prices.termo_energia)}
                                        value={form.gas_prices && replaceDots(form.gas_prices.termo_energia)} 
                                        onChange={(e) => onChange('gas_prices', 'termo_energia', e)}/>
                                </InputBox>
                            </Col>
                        } 
                    </Row>
                    <InputBox>
                        <CheckForm
                            label={`Manter os mesmos descontos aplicados ao tarifário?`}
                            value={form.apply_refunds}
                            onClick={() => onChange('', 'apply_refunds', '')}
                        />
                    </InputBox>
                </Wrapper>
            </Modal>
        )
    }
}

const Wrapper = styled.div`
    padding: 20px;
    width: 100%;
`

const Row = styled.div`
    display: flex;
    flex-direction: row;
`

const InputForm = styled(Input)`
    width: 100%;
    margin-bottom: 5px;
`

const CheckForm = styled(CheckInput)`
    color: #676767;
    font-family: Nunito;
    font-size: 14px;
    line-height: 18px;
`

const Col = styled.div`
    display: flex;
    flex-direction: column;
    width: 50%;
    padding: ${({ eletricty }) => eletricty ? ` 0 20px 0 0 ` : `0 0 0 20px`};
    ${({ hasEletricity }) => !hasEletricity && `
        padding-left: 0px !important;
    `}

    ${({ eletricty }) => eletricty && `
        border-right: 1px solid #F9F9F9;
    `}
`

const InputBox = styled.div`
    ${({ first }) => !first && `
        margin-top: 20px;
    `}
`

const Title = styled.span`
  display: block;
  color: #3E3E3E;
  font-family: Nunito;
  font-size: 17px;
  font-weight: bold;
  line-height: 14px;
  margin-bottom: 20px;
`

const EletricityIcon = styled.img`
  max-width: 4%;
  position: relative;
  top: 5px;
  margin-right: 5px;
`

const GasIcon = styled.img`
  max-width: 5%;
  margin-right: 5px;
`



// WEBPACK FOOTER //
// ./src/components/EditPricesModal/index.js